import {Col, Row} from 'antd';
import React from 'react';

import BoxContent from '../../../../components/BoxContent/BoxContent';
import InformativeText from '../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../utils/commonFunctions';
import LabelChart from '../../components/LabelChart';
// import TotalChartList from '../../components/TotalChartList';
import ValueRepresentationBox from '../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../constants/commonConstants';
import AllSuppliers from '../../supplyChain/utils/AllSuppliers';

const OperationalProducts: React.FC<{data: any[]}> = ({data}) => {
  const productInfo = InformativeText?.NZM?.products;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
        <Col span={20} style={{height: '100%'}}>
          <AllSuppliers
            data={data}
            keyArray={['product quantity']}
            type="productMain"
            customTitle="TOTAL NO. PRODUCT"
          />
        </Col>
        <Col span={4}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey={'recycling rate of end of life products'}
                showTotal={false}
                labelType="percent"
                tooltip={productInfo?.Recycled_and_reused_input_material}
                customLabel={undefined}
                checkSingle={false}
              />
            </Col>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey={
                  'recycled or reused input material as percentage of total input material'
                }
                showTotal={false}
                labelType="percent"
                tooltip={productInfo?.Reclaimed_Products}
                customLabel={undefined}
                checkSingle={false}
              />
            </Col>
          </Row>
        </Col>

        {/* <Col span={4}>
        <Row gutter={rowGutterNZM} style={{height: convertPxToRem(926)}}>
          <Col span={24} style={{height: convertPxToRem(239.5)}}>
            <ValueRepresentationBox
              data={data}
              mainKey="franchise carbon intensity"
              tooltip={assetInformative.Franchise_Carbon_Intensity}
              smallImage={true}
            />
          </Col>
          <Col span={24} style={{height: convertPxToRem(666)}}>
            <BoxContent />
          </Col>
        </Row>
      </Col>  */}
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
        <Col span={10}>
          <AllSuppliers
            data={data}
            keyArray={['raw material data']}
            type="productSub"
            customTitle="TOTAL QUANTITY RAW MATERIAL"
            sumOfKey="value"
          />
        </Col>
        <Col span={6}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
            <Col span={24}>
              <LabelChart
                data={data}
                keyArray={[
                  'intermediate and final product data',
                  'total intermediate',
                  'total final product'
                ]}
                chartType="progress"
                tooltip={productInfo?.Intermediate_and_Final_product_data}
                customLabel="TOTAL PRODUCTS"
              />
            </Col>
            <Col span={24} style={{height: convertPxToRem(181)}}>
              <BoxContent />
            </Col>
          </Row>
        </Col>
        <Col span={8}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey={'reclaimed products and their packaging material'}
                showTotal={false}
                labelType="percent"
                tooltip={productInfo?.Reclaimed_Products}
                customLabel={undefined}
                checkSingle={false}
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey={'percentage of products sold that are recyclable'}
                showTotal={false}
                labelType="percent"
                customLabel={undefined}
                checkSingle={false}
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey={'weight of end of life material recovered'}
                showTotal={true}
                labelType="percent"
                tooltip={productInfo?.Weight_end_of_life}
                customLabel={undefined}
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey={'recyclability ratio of products sold'}
                showTotal={true}
                labelType="percent"
                tooltip={productInfo?.Recyclability_Ratio}
                valueType="string"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default OperationalProducts;
